import { render, staticRenderFns } from "./PatientRecordModal.vue?vue&type=template&id=eb189748"
import script from "./PatientRecordModal.vue?vue&type=script&lang=js"
export * from "./PatientRecordModal.vue?vue&type=script&lang=js"
import style0 from "./PatientRecordModal.vue?vue&type=style&index=0&id=eb189748&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports